import { axiosClient } from "services/axios";

import { Item, PriceListItem } from "../../types";

import { SimpleGetParams } from "../types";

export function getStorePriceList(): Promise<PriceListItem[] | void> {
  return axiosClient.get("stores/pricelists").then((res) => res.data);
}

export function getArticlesList({ page = 1, pageSize = 100 }: SimpleGetParams) {
  return axiosClient
    .get("article/", { params: { page, pageSize } })
    .then((res) => res.data);
}

export function getEmployeesGroups() {
  return axiosClient.get("users/get-groups").then((res) => res.data);
}

export function getDocumentsTypes() {
  return axiosClient
    .get("documents/operation-types", { params: { page: 1, pageSize: 100 } })
    .then((res) => res.data);
}
